module.exports = __webpack_public_path__ + "img/logo-github.19932d27.svg";